import React from 'react';
import DynamicCrudPage from '../../../components/DynamicCrudPage';
import { useContractSubjects, useCompanies } from '../../../hooks';
import AddIcon from '@mui/icons-material/Add';

const ContractSubjectsPage = () => (
  <DynamicCrudPage
    entityType="contractSubjects"
    hook={useContractSubjects}
    additionalHooks={{ companies: useCompanies }}
    addButtonTextKey="table.actions.addContractSubject"
    addButtonIcon={<AddIcon />}
    entityTypeForDataTable="contractSubject"
  />
);

export default ContractSubjectsPage;
